/* React */
import React from "react";

/* Components */
import OperatorContainer from "src/components/insights/custom-cohorts/cohort-builder/cohort-segment/operator-container/OperatorContainer";

/* Stylesheet */
import styles from "./InitialSegment.module.scss";

/* Interfaces */
import {
  BasicProps,
  LogicalProps,
} from "src/shared/interfaces/custom-cohorts/CustomCohorts";

interface InitialSegmentProps {
  isSegment: (
    segment: BasicProps | LogicalProps
  ) => segment is LogicalProps;
  segments: BasicProps | LogicalProps;
  disabled: boolean;
  handleSegments: (
    segment: BasicProps | LogicalProps
  ) => void;
}

const InitialSegment: React.FC<InitialSegmentProps> = ({
  isSegment,
  segments,
  disabled,
  handleSegments,
}) => {
  return (
    <div className={styles.initial_segment}>
      <div className={styles.block_container}>
        <div
          style={{
            color: disabled
              ? "var(--ion-color-text-disabled)"
              : "var(--ion-color-text-primary)",
          }}
          className={styles.label_container}
        >
          <div className={styles.label}>
            Create a new <span>Custom Cohort</span> <br />
            Press one of the buttons below
            <div className={styles.dot_loader}>
              <span className={styles.dot}></span>
              <span className={styles.dot}></span>
              <span className={styles.dot}></span>
            </div>
          </div>
        </div>
        <OperatorContainer
          isSegment={isSegment}
          segments={segments}
          disabled={disabled}
          handleSegments={handleSegments}
        />
      </div>
    </div>
  );
};

export default InitialSegment;
